module.exports = __webpack_public_path__ + "static/media/footer_5.8824731a.png";